const decodeToken = () => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    try {
      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(window.atob(base64));
      return payload;
    } catch (error) {
      console.error("Errore nelal decodifica del token:", error);
      return null;
    }
  }
  return null;
};

export const getUserCurrentlyLogged = () => {
  const payload = decodeToken();
  return payload ? payload.email : null;
};

export const getUserRole = () => {
  // Otteniamo il ruolo dell'utente dal tooken JWT in modo che non sia manipolabile dall'utente
  const payload = decodeToken();
  return payload ? payload.role : null;
};

export const isUserAdmin = () => {
  const payload = decodeToken();
  console.log("Token payload:", payload); // Questo mostrerà il contenuto del token nei console log
  const role = getUserRole();
  console.log("User role:", role); // Questo mostrerà il ruolo estratto
  return role === "admin";
};
